export class FindAllApisError {
  public static readonly type = '[Project/Api/List] FindAllApisError';
  constructor(public readonly error: Error) {}
}
